// extracted by mini-css-extract-plugin
export default {"root":"TabArrows_root__YhEsv","btn":"TabArrows_btn__SYddo"};